<template>
  <v-card style="height:100%">
    <v-card-title class="grey lighten-4">
      <span class="title primary--text">Search Trending Packages</span>
    </v-card-title>
    <v-autocomplete
      v-model="model"
      :items="states"
      label="Select Category"
      clearable
      class="mx-3"
    >
      <v-slide-x-reverse-transition
        slot="append-outer"
        mode="out-in"
      >
      </v-slide-x-reverse-transition>
    </v-autocomplete>
    <div v-if="getValues" class="mx-3">
      <div v-for="item in getValues" class="py-1">
        <v-icon>work</v-icon>
        {{ item }}
      </div>
    </div>
    <v-layout align-center v-else column class="mt-3">
      <v-flex><v-icon x-large>work</v-icon></v-flex>
      <v-flex class="display-2 secondary--text">21</v-flex>
      <v-flex class="subheading primary--text">Trending Packages</v-flex>
    </v-layout>
  </v-card>
</template>
<script>
  export default {
    data () {
      return {
        model: null,
        states: [
          'Technology | Domain | Engineering', 'Business Skills',
          'Trending Behavioural', 'HR/L&D Strategy', 'Executing Coaching',
          'Leadership Development', 'Assessments', 'OD'
        ]
      }
    },
    computed: {
      getValues: function () {
        if (this.model === 'Technology | Domain | Engineering') {
          return ['Blockchain', 'AI', 'Analytics', 'Big Data and Ecosystem', 'Business Intelligence', 'Cloud Computing', 'IoT']
        }
        if (this.model === 'Business Skills') {
          return ['Customer Service', 'Sales - Value Selling, Consultative Selling', 'Account Management']
        }
        if (this.model === 'Trending Behavioural') {
          return ['Mindfulness', 'Storytelling', 'Emotional Intelligence']
        }
        if (this.model === 'HR/L&D Strategy') {
          return ['TNI/TNA', 'Facilitation Skills - Human Process Facilitation / Lab based Facilitation Skills']
        }
        if (this.model === 'Executing Coaching') {
          return ['CEO Coaching']
        }
        if (this.model === 'Leadership Development') {
          return ['Innovation, Creativity', 'Change Management']
        }
        if (this.model === 'Assessments') {
          return ['EQ_i_2.0']
        }
        if (this.model === 'OD') {
          return ['Culture, Trust', 'Team']
        }
        return null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/TrendingPackages.vue